import { render, staticRenderFns } from "./AditionalContractProductie.vue?vue&type=template&id=8f3791ba&scoped=true"
import script from "./AditionalContractProductie.vue?vue&type=script&lang=js"
export * from "./AditionalContractProductie.vue?vue&type=script&lang=js"
import style0 from "./AditionalContractProductie.vue?vue&type=style&index=0&id=8f3791ba&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3791ba",
  null
  
)

export default component.exports